import { getModules } from './module.config.js';
import { Logs, Intersection } from '../shared';
export default class ModuleLoader extends Intersection {

  constructor(node, wrapper, callback) {
    super(node);
    this.node = node;
    this.wrapper = wrapper;
    this.callback = callback;
    this.name = node.getAttribute('data-module');
    this.options = node.getAttribute('data-module-options');
    this.createObserver();
  }

  onIntersect() {
    this.loadModule().catch(error => {
      console.error(`Module "${this.name}" has not been loaded correctly. Check the attribute data-module on html or paths on module.config.js - ${error}`)
    });;
  }

  loadModule() {
    // return a promise when module is loaded
    return new Promise((resolve, reject) => {
      const startTime = Date.now();

      //load module, create a new module instance and bind it
      getModules[this.name]().then(({ createInstance }) => {
        this.instance = createInstance();
        this.instance.bind(this.node, this.name, this.options);

        //show styled node on module ready and calculate elapsed time
        this.instance.on('ready', (endingTime) => {
          Logs.debug(`Module "${this.name}" loaded in ${endingTime - startTime}ms`);
          this.instance.node.classList.add('_loaded');
          this.instance.off('ready');
          this.callback && this.callback();
          resolve(this.instance)
        })
      });
    });
  }

  static moduleLoader(context, callback) {
    const modules = context.querySelectorAll('[data-module]');
    return Array.from(modules).map((node) => new ModuleLoader(node, this.body, callback));
  }

  static loadAllModules(modules, callback) {
    let modulesToLoad = modules.filter(x => !x.intersected);
    modulesToLoad = modules.map(x => {
      x.intersected = true;
      return x.loadModule();
    });
    Promise.all(modulesToLoad).then(data => {
      Logs.debug(`All modules loaded`);
      callback && callback();
    })
  }

  static resetAllModules(modules) {
    modules.forEach(module => {
      module.instance && module.instance.destroy();
    });
  }
}
